/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_1_PInputs */

const en_terms_1_p = /** @type {(inputs: Terms_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep generates product requirement documents, feature breakdowns and task lists from your input, and provides tooling to hand those tasks to an AI coding agent. Output is produced by AI and may be incomplete or wrong; you are responsible for reviewing it before relying on it.`)
};

const id_terms_1_p = /** @type {(inputs: Terms_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menghasilkan dokumen kebutuhan produk, rincian fitur, dan daftar task dari masukanmu, serta menyediakan alat untuk menyerahkan task itu ke agen AI coding. Keluaran dibuat oleh AI dan bisa tidak lengkap atau keliru; kamu bertanggung jawab meninjaunya sebelum mengandalkannya.`)
};

/**
* | output |
* | --- |
* | "Bystep generates product requirement documents, feature breakdowns and task lists from your input, and provides tooling to hand those tasks to an AI coding a..." |
*
* @param {Terms_1_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_1_p = /** @type {((inputs?: Terms_1_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_1_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_1_p(inputs)
	return en_terms_1_p(inputs)
});